import React from "react";
import { motion } from "framer-motion";
import { fadeUp, stagger, slideLeft, slideRight, viewportOnce } from "../../lib/animations";
import { Globe } from "../ui/globe";

export default function Mission() {
  const imageSrc = null;

  return (
    <section
      id="mission"
      className="relative overflow-hidden"
      style={{
        background:
          "radial-gradient(70% 60% at 18% 20%, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0) 62%), radial-gradient(60% 55% at 72% 30%, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0) 60%), linear-gradient(180deg, #1A1060 0%, #130A48 100%)",
      }}
      data-testid="mission-section"
    >
      <div className="absolute inset-0 pointer-events-none z-0 section-noise" />

      <div
        className="relative z-10 max-w-[1100px] mx-auto px-4 py-[40px] sm:px-6 sm:py-[50px] md:px-[60px] md:py-[96px]"
        style={{ marginTop: 0, marginBottom: 0 }}
      >
        <div className="grid grid-cols-1 md:grid-cols-[52%_48%] gap-12 md:gap-[72px] md:items-center">
          <motion.div variants={stagger} initial="hidden" whileInView="visible" viewport={viewportOnce}>
            <motion.div
              variants={slideRight}
              className="flex items-center gap-3"
              style={{ fontFamily: "Syne, system-ui, -apple-system, sans-serif" }}
            >
              <span className="w-[28px] h-px" style={{ background: "#C9A84C" }} />
              <span
                className="text-[10px] font-semibold uppercase"
                style={{ letterSpacing: "0.22em", color: "#C9A84C" }}
              >
                OUR MISSION
              </span>
            </motion.div>

            <motion.h2
              variants={slideRight}
              className="mt-5 max-w-[560px] text-[28px] sm:text-[32px] md:text-[38px] lg:text-[54px] font-bold tracking-tight"
              style={{
                fontFamily: '"Cormorant Garamond", serif',
                color: "#F0EBE1",
                lineHeight: 1.05,
              }}
            >
              We ensure South African businesses{" "}
              <span style={{ fontStyle: "italic", color: "#C9A84C" }}>never lose</span>{" "}
              <span style={{ color: "#F0EBE1" }}>what they've earned.</span>
            </motion.h2>

            <motion.div variants={fadeUp} className="w-full h-px my-9" style={{ background: "rgba(255,255,255,0.08)" }} />

            <motion.div variants={fadeUp} className="flex flex-col gap-8">
              <div>
                <div className="flex items-center gap-[10px]">
                  <span
                    className="text-[12px]"
                    style={{
                      fontFamily: '"Cormorant Garamond", serif',
                      color: "#C9A84C",
                      opacity: 0.6,
                    }}
                  >
                    01
                  </span>
                  <span
                    className="text-[15px] font-semibold"
                    style={{ fontFamily: "Syne, system-ui, -apple-system, sans-serif", color: "#F0EBE1" }}
                  >
                    Smart recovery, not chasing.
                  </span>
                </div>
                <div className="mt-3 h-px w-full" style={{ background: "rgba(255,255,255,0.07)" }} />
                <p
                  className="mt-4 text-[13px]"
                  style={{
                    fontFamily: "Syne, system-ui, -apple-system, sans-serif",
                    color: "rgba(240,235,225,0.48)",
                    lineHeight: 1.8,
                  }}
                >
                  Traditional recovery methods can't keep up with automated payment failures. We built technology that works faster than the systems working against you.
                </p>
              </div>

              <div>
                <div className="flex items-center gap-[10px]">
                  <span
                    className="text-[12px]"
                    style={{
                      fontFamily: '"Cormorant Garamond", serif',
                      color: "#C9A84C",
                      opacity: 0.6,
                    }}
                  >
                    02
                  </span>
                  <span
                    className="text-[15px] font-semibold"
                    style={{ fontFamily: "Syne, system-ui, -apple-system, sans-serif", color: "#F0EBE1" }}
                  >
                    We only win when you win.
                  </span>
                </div>
                <div className="mt-3 h-px w-full" style={{ background: "rgba(255,255,255,0.07)" }} />
                <p
                  className="mt-4 text-[13px]"
                  style={{
                    fontFamily: "Syne, system-ui, -apple-system, sans-serif",
                    color: "rgba(240,235,225,0.48)",
                    lineHeight: 1.8,
                  }}
                >
                  No setup fees, no monthly costs, no risk. We earn a percentage only after we recover your revenue. Our success is literally tied to yours.
                </p>
              </div>
            </motion.div>

            <motion.a
              variants={fadeUp}
              href="#founder"
              className="inline-flex items-center gap-2 mt-10 rounded-full border border-[rgba(201,168,76,0.35)] px-7 py-3 text-[11px] font-semibold uppercase tracking-[0.16em] text-[#C9A84C] bg-transparent hover:bg-[rgba(201,168,76,0.08)] hover:border-[rgba(201,168,76,0.6)] transition-colors"
              style={{
                fontFamily: "Syne, system-ui, -apple-system, sans-serif",
                transitionDuration: "250ms",
                transitionTimingFunction: "ease",
              }}
            >
              ABOUT CROWN LEDGER <span aria-hidden="true">↗</span>
            </motion.a>
          </motion.div>

          <motion.div variants={slideLeft} initial="hidden" whileInView="visible" viewport={viewportOnce}>
            <div className="relative">
              <div
                className="w-full aspect-square relative"
                style={{
                  background: "transparent",
                  border: "none",
                }}
              >
                {imageSrc ? (
                  <img src={imageSrc} alt="South African professional at a desk" className="w-full h-full object-cover" />
                ) : (
                  <div className="absolute inset-0">
                    <Globe className="max-w-none" />
                  </div>
                )}
              </div>

              
            </div>
          </motion.div>
        </div>
      </div>

      <div
        aria-hidden="true"
        className="w-full select-none leading-none"
        style={{
          fontFamily: '"Cormorant Garamond", serif',
          fontWeight: 700,
          fontSize: "clamp(64px, 9vw, 108px)",
          color: "transparent",
          WebkitTextStroke: "1px rgba(255,255,255,0.055)",
        }}
      >
        MISSION
      </div>

      <div
        aria-hidden="true"
        className="hidden md:grid absolute bottom-10 right-12 z-10"
        style={{
          gridTemplateColumns: "repeat(6, 6px)",
          gridTemplateRows: "repeat(4, 6px)",
          gap: 14,
        }}
      >
        {Array.from({ length: 24 }).map((_, idx) => (
          <span
            key={idx}
            className="block"
            style={{
              width: 0,
              height: 0,
              borderLeft: "3px solid transparent",
              borderRight: "3px solid transparent",
              borderBottom: "6px solid rgba(255,255,255,0.12)",
            }}
          />
        ))}
      </div>
    </section>
  );
}
